<template>
  <div class="forms">
    <div class="form-wrapper">
      <div class="form-wrapper--box box is-flex">
        <div class="notification">
          ⚠️ This is not a real login. It is just for testing purposes.
        </div>

        <form method="get">
          <div class="field">
            <label class="label">Username</label>
            <div class="control">
              <input class="input" name="username" type="text" placeholder="Username">
            </div>
          </div>

          <div class="field">
            <label class="label">Password</label>
            <div class="control">
              <input class="input" name="password" type="password" placeholder="Password">
            </div>
          </div>

          <div class="field is-grouped buttons">
            <div class="control">
              <button type="submit" class="button is-link">Submit</button>
            </div>
            <div class="control">
              <button type="reset" class="button is-link is-light">Reset</button>
            </div>
          </div>
        </form>
      </div>
      <div class="form-wrapper-footer is-flex">
        <button type="button" class="button is-text" @click="onHelpClicked">I need Help!</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    onHelpClicked() {
      const event = new CustomEvent('i-need-help', {
        detail: 'this will be ignored',
      });

      document.dispatchEvent(event);
    },
  },
};
</script>

<style scoped>
  .form-wrapper {
    max-width: 400px;
    margin: 100px auto;
  }

  .form-wrapper--box {
    flex-direction: column;
  }

  .form-wrapper-footer {
    align-items: center;
    justify-content: center;
  }

  .form-wrapper .buttons {
    margin-top: 20px;
  }
</style>
